// incomingMessageSound.js — play a short sound for new incoming channel messages

export const INCOMING_MESSAGE_SOUND_URL = '/sounds/bloop.mp3';

export function playIncomingMessageSound() {
  try {
    const audio = new Audio(INCOMING_MESSAGE_SOUND_URL);
    audio.play().catch(() => {});
  } catch {
    // Ignore autoplay or load failures.
  }
}

export function isIncomingChannelMessage(message, currentUserKey) {
  const messageKey = String(message?.key || '').trim();
  const messageUserKey = String(message?.userKey || '').trim();
  const cleanCurrentUserKey = String(currentUserKey || '').trim();

  if (!messageKey || !messageUserKey) return false;
  if (!cleanCurrentUserKey) return true;
  if (messageUserKey === cleanCurrentUserKey) return false;

  return true;
}
